import React from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'

const FAQModal = () => {
  const [open, setOpen] = React.useState(false)

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={
        // <Button floated="left" primary>
        //   <Icon name="info" /> About
        // </Button>
        <button className="buttons about_button">
          <Icon name="ellipsis vertical" />
        </button>
      }
    >
      <Modal.Header>About Waste Water Heat Online</Modal.Header>
      <Modal.Content content wrapped scrolling>
        <Modal.Description>
                <p>
                  Wastewaterheat.online is an information portal available for any
                  city in the world to use, for displaying the heating & cooling
                  energy available within their city wastewater network. This heating
                  & cooling energy can be captured and recycled, instead of it being
                  flushed away and wasted.
                </p>
                <p>
                  All of the data displayed on this portal has been provided to
                  wastewaterheat.online by the respective city or their authorised
                  agents. We cannot therefore be held responsible for the accuracy of
                  any said data.
                </p>
                <p>
                  To contact us, please email 
                  <a href="mailto:contact@wastewaterheat.online">
                    contact@wastewaterheat.online
                  </a>
                </p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)} color="green">
          Continue <Icon name="chevron right" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default FAQModal;
